import { render, staticRenderFns } from "./MultiImageUploader.vue?vue&type=template&id=3935bd1c&scoped=true"
import script from "./MultiImageUploader.vue?vue&type=script&lang=js"
export * from "./MultiImageUploader.vue?vue&type=script&lang=js"
import style0 from "./MultiImageUploader.vue?vue&type=style&index=0&id=3935bd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935bd1c",
  null
  
)

export default component.exports